import React from "react";
import { v4 as uuid } from "uuid";
import "./index.css";

const SolutionsChild = ({ list }) => {
  return (
    <>
      {list.map(({ title, imageData, text }) => {
        return (
          <div key={uuid()} className="a2b-solutions-card">
            <div className="a2b-solutions-card__image">
              <img
                src={imageData.image}
                alt={title}
                width={imageData.width}
                height={imageData.height}
              />
            </div>
            <h3 className="a2b-solutions-card__title">{title}</h3>
            <p className="a2b-solutions-card__text">{text}</p>
          </div>
        );
      })}
    </>
  );
};

export default SolutionsChild;
